import { Component, Inject, Input, OnChanges, OnDestroy, OnInit, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProductsLoadingService } from '~app/modules/catalog/services/products-loading.service';
import {
  CatalogState,
  getCustomPlpSeoContent,
  getCustomPlpTitle,
  getSearchCorrection,
} from '~app/modules/catalog/store';
import { select, Store } from '@ngrx/store';
import { TitleService } from '~shared/services/title.service';
import { ProductsListUrlService } from '~app/modules/generic/services/products-list-url.service';
import { getActiveUrlWithoutParameters } from '~core/store';
import { SeoContent } from '~shared/models';
import { CommonProps } from '~app/modules/catalog/models';
import { isPlatformServer } from '@angular/common';
import { StoryblokApiResponse } from '~app/modules/storyblok/models/storyblok-api-response.model';

@Component({
  selector: 'app-catalog',
  templateUrl: './catalog.component.html',
  styleUrls: ['./catalog.component.scss'],
  providers: [ProductsLoadingService],
})
export class CatalogComponent implements OnInit, OnChanges, OnDestroy {
  @Input() commonProps = {} as CommonProps;

  isSearchPage: boolean;
  isCustomPLPPage: boolean;
  seoContent$: Observable<SeoContent>;
  searchCorrection$: Observable<string>;
  isServer: boolean = isPlatformServer(this.platformId);
  story$: Observable<StoryblokApiResponse>;

  private unsubscribe$ = new Subject();

  constructor(
    private store$: Store<CatalogState>,
    private titleService: TitleService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private productsListService: ProductsListUrlService
  ) {}

  ngOnInit() {
    this.subscribeToRouterChanges();

    if (this.isSearchPage) {
      this.setSearchPageTitle();
      this.initializeAutoCorrection();
    }

    if (this.isCustomPLPPage) {
      // If I am here I know is bc plp FF for custom is OFF, so I just load CMS data
      this.loadCustomPLPCMSData();
      this.setCustomPlpTitle();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['commonProps'].currentValue.searchQuery && this.isSearchPage) {
      this.setSearchPageTitle();
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private subscribeToRouterChanges(): void {
    this.store$
      .pipe(select(getActiveUrlWithoutParameters))
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(([_]) => {
        this.isSearchPage = this.productsListService.isSearchPage();
        // @TODO: Every isCustomPLPPage check can be removed once 'custom' in FF_MACO_STORYBLOK_PLPS is gone
        this.isCustomPLPPage = this.productsListService.isCustomPLPPage();
      });
  }

  // Search ____________
  private setSearchPageTitle(): void {
    this.titleService.setTitle([this.commonProps?.searchQuery, { title: 'TITLE.PAGE.SEARCH' }]);
  }

  private initializeAutoCorrection(): void {
    this.searchCorrection$ = this.store$.pipe(select(getSearchCorrection), takeUntil(this.unsubscribe$));
  }

  // Custom ____________
  private setCustomPlpTitle(): void {
    this.store$.pipe(select(getCustomPlpTitle), takeUntil(this.unsubscribe$)).subscribe((title) => {
      if (title) {
        this.titleService.setTitle([title, { title: 'TITLE.PAGE.LANDING_PAGE' }]);
      }
    });
  }

  private loadCustomPLPCMSData(): void {
    this.seoContent$ = this.store$.pipe(select(getCustomPlpSeoContent), takeUntil(this.unsubscribe$));
  }
}
